import { createDataMapper } from '@common/utils/query/dataMappers';
import {
    CarrickWorkflowStartResponse,
    StartCarrickWorkflowArgs,
} from '../types';

export const carrickStartResponseMapper = createDataMapper<
    CarrickWorkflowStartResponse,
    string,
    StartCarrickWorkflowArgs
>((response) => response.id);
